interface Props {
  lotteryNumber: number;
  eventName?: string;
}

export function SuccessPage({ lotteryNumber, eventName }: Props) {
  return (
    <div>
      <div className="header">
        <div className="logo">Клиника Авиценна</div>
        <h1 className="title">Спасибо!</h1>
        {eventName && <p className="subtitle">{eventName}</p>}
      </div>

      <div className="card lottery">
        <p className="subtitle">Ваш номер для участия в лотерее</p>
        <div className="lottery-number">{lotteryNumber}</div>
        <p className="subtitle">
          Сохраните этот номер. Победители будут определены в конце мероприятия.
        </p>
      </div>

      <div className="card">
        <p style={{ margin: 0, fontSize: 14, lineHeight: 1.5 }}>
          Благодарим за участие! Если у вас остались вопросы о клинике Авиценна в Новосибирске,
          наши администраторы будут рады помочь.
        </p>
      </div>
    </div>
  );
}
